// extracted by mini-css-extract-plugin
export default {"h1":"Htag_h1__gVoiK","h2":"Htag_h2__cop-i","h3":"Htag_h3__+xeZD","h4":"Htag_h4__4BXVZ","homeHeader":"Htag_homeHeader__9+57T","b1":"Htag_b1__b0kpF","b2":"Htag_b2__mBAcz"};